import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const NavBar = () => {
  const { user, login, logout } = useAuth();

  const handleLogin = () => {
    // Demo login with the first user
    login('demo@vrai3d.com', 'password123');
  };

  return (
    <nav className="nav-bar">
      <Link to="/">Home</Link>
      <Link to="/gallery">Gallery</Link>
      <Link to="/vr">VR Mode</Link>
      <div>
        {user ? (
          <>
            <span>Welcome, {user.email}!</span>
            <button onClick={logout}>Logout</button>
          </>
        ) : (
          <button onClick={handleLogin}>Login (Demo)</button>
        )}
      </div>
    </nav>
  );
};

export default NavBar;
